















import {
  computed,
  defineComponent,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';

import getDebtorListForSelector from '@/gql/invoice/getDebtorListForSelector.gql';

const CommonSelectWithCompanyList = defineComponent({
  props: {
    value: { type: [Number, String, Object], default: undefined },
    label: { default: 'ชื่อบริษัท' },
    placeholder: { default: 'โปรดเลือกบริษัท' },
    rules: { default: '' },
  },
  setup(props, { emit }) {
    const _value: Ref<number | string> = ref('');
    watch(() => props.value, (newVal, oldVal) => {
      if (props.value > -1 && newVal !== oldVal) _value.value = props.value;
    });
    function inputHandler($event: any) {
      _value.value = $event;
      emit('input', $event);
    }

    const { result: debtorListResult, loading } = useQuery(getDebtorListForSelector);
    const debtorList = useResult(debtorListResult, [], (data) => data.debtors.data);
    const debtors = computed(() => {
      const list: string[] = [];
      const display: string[] = [];
      if (!loading) return { list, display };
      debtorList.value.forEach((debtor: { id: string; name: string }) => {
        list.push(debtor.id);
        display.push(debtor.name);
      });
      return { list, display };
    });

    return {
      getDebtorListForSelector,
      result: (data: any) => data.debtors.data,

      inputHandler,
      _value,
    };
  },
});

export default CommonSelectWithCompanyList;
